import React from 'react'
import director from "../images/director photo.jpg";
import manager from "../images/assistance.jpg";


function Profile() {
    return (
        <div>

            <div className="album py-1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 mt-3">

                            <img src={director} className="card-img-top" alt="director_Saptarshi Sarkar"/>

                        </div>
                        <div className="col-md-6 mt-3">


                            <div className="card-body">
                            <div className='colorname'>
                                <h1 className="card-title mb-2"><b>Saptarshi Sarkar</b></h1>
                                </div>
                            
                                <p className="card-text mb-2">FOUNDER & MANAGING DIRECTOR</p>
                                <p style={{color:"grey"}} className="card-text"><b>Saptarshi Sarkar</b> is the Managing Director of The Love Bird's Icecream, a company specializing in crafting premium, artisanal ice creams. Known for its innovative flavors and high-quality ingredients, the brand caters to a diverse clientele, ranging from traditional ice cream lovers to those seeking unique and exotic tastes. Under Saptarshi Sarkar's leadership, the company has gained recognition for its commitment to sustainability, customer satisfaction, and constant innovation in the frozen dessert industry.</p>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
<br/>
<br/>
            <div className="album py-4">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 mt-3">

                        <div className="card-body">
                            <div className='colorname'>
                                <h1  className="card-title mb-2"><b>Tuhin Mondal</b></h1>
                                </div>
                                <p className="card-text">PERSONAL MANAGER</p>

                            </div>
                           

                        </div>
                        <div className="col-md-6 mt-3">

                        <img src={manager} className="card-img-top" alt="manager_thelovebird's Icecream"/>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
        </div>


    )
}

export default Profile